import { render, staticRenderFns } from "./CarThroughputStatics.vue?vue&type=template&id=4874d9d4&scoped=true&"
import script from "./CarThroughputStatics.vue?vue&type=script&lang=js&"
export * from "./CarThroughputStatics.vue?vue&type=script&lang=js&"
import style0 from "./CarThroughputStatics.vue?vue&type=style&index=0&id=4874d9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874d9d4",
  null
  
)

export default component.exports